import { ContentVersionSource } from "../types/ContentVersionSource";

interface BuzzVersion {
    id: string;
    name: string;
    notes?: string;
    isArchived: boolean;
}

interface ShreqVersion {
    id: string;
    name: string;
}

export const mapToVersionSource = <
    T extends { isTrailer?: boolean; buzzVersion?: BuzzVersion; shreqVersion?: ShreqVersion }
>(
    version: T
): ContentVersionSource => {
    if (version.isTrailer) {
        return ContentVersionSource.Trailer;
    }

    if (version.buzzVersion) {
        return ContentVersionSource.Buzz;
    }

    if (version.shreqVersion) {
        return ContentVersionSource.Shreq;
    }

    return ContentVersionSource.Sprint;
};
